export default __webpack_public_path__ + "static/media/MotherDay_13.ef3063ed.png";